import { render, staticRenderFns } from "./reportType.vue?vue&type=template&id=32322f5f"
import script from "./reportType.vue?vue&type=script&lang=js"
export * from "./reportType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports